module.exports = __webpack_public_path__ + "static/media/icon-youtube.6cbf34c2.svg";